/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SmsAutoDisableStatus } from './SmsAutoDisableStatus';
import {
    SmsAutoDisableStatusFromJSON,
    SmsAutoDisableStatusFromJSONTyped,
    SmsAutoDisableStatusToJSON,
} from './SmsAutoDisableStatus';

/**
 * 
 * @export
 * @interface FindSmsDeliveryStatus200Response
 */
export interface FindSmsDeliveryStatus200Response {
    /**
     * 
     * @type {SmsAutoDisableStatus}
     * @memberof FindSmsDeliveryStatus200Response
     */
    data?: SmsAutoDisableStatus | null;
}

/**
 * Check if a given object implements the FindSmsDeliveryStatus200Response interface.
 */
export function instanceOfFindSmsDeliveryStatus200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindSmsDeliveryStatus200ResponseFromJSON(json: any): FindSmsDeliveryStatus200Response {
    return FindSmsDeliveryStatus200ResponseFromJSONTyped(json, false);
}

export function FindSmsDeliveryStatus200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindSmsDeliveryStatus200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : SmsAutoDisableStatusFromJSON(json['data']),
    };
}

export function FindSmsDeliveryStatus200ResponseToJSON(value?: FindSmsDeliveryStatus200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': SmsAutoDisableStatusToJSON(value.data),
    };
}

